import { useEffect } from 'react';
import { NavMarker } from 'react-rhumb';
import FormattedMessage from 'I18n/components/FormattedMessage';
import { MainContentLayout } from '../components/layouts/MainContentLayout';
import { PaymentHistoryTable } from './PaymentHistoryTable';
import { trackPageView } from '../utils/usageTracker';
import { jsx as _jsx } from "react/jsx-runtime";
export const PaymentHistoryPage = () => {
  useEffect(() => {
    trackPageView('payment-history-overview');
  }, []);
  return /*#__PURE__*/_jsx(NavMarker, {
    name: "PAYMENT_HISTORY_OVERVIEW_LOAD",
    children: /*#__PURE__*/_jsx(MainContentLayout, {
      title: /*#__PURE__*/_jsx(FormattedMessage, {
        message: "paymentHistory.title"
      }),
      children: /*#__PURE__*/_jsx(PaymentHistoryTable, {})
    })
  });
};